import config from '../../config/config';
import AuthHeader from '../../helpers/AuthHeader';

export const entityFiltersService = {
  getEntityFilter,
  getAllEntityFilters,
  updateEntityFilter,
  createFilter,
  destroyFilter
}

function destroyFilter(id){
  const url = `${config.apis.orthus}/v1/territory_filters/${id}`;

  return fetch(url, {
    method: 'DELETE',
    headers: AuthHeader({ 'content-type': 'application/json' })
  }).then( res => res.json());
}

function createFilter(params){

  const url = `${config.apis.orthus}/v1/territory_filters`;

  return fetch( url, {
    method: 'POST',
    headers: AuthHeader({'content-type': 'application/json'}),
    body: JSON.stringify(params)
  }).then( res => res.json());
}

function getEntityFilter(id){
  const url = `${config.apis.orthus}/v1/territory_filters/${id}`;

  return fetch( url, {
    method: 'GET',
    headers: AuthHeader()
  }).then( res => res.json());
}

function getAllEntityFilters(){
    const url = `${config.apis.orthus}/v1/territory_filters`;

    return fetch( url, {
      method: 'GET',
      headers: AuthHeader()
    }).then( res => res.json());
  }


function updateEntityFilter(id, filter){
  const url = `${config.apis.orthus}/v1/territory_filters/${filter.id}`;

  return fetch( url, {
    method: 'PATCH',
    headers: AuthHeader({'content-type': 'application/json'}),
    body: JSON.stringify(filter)
  }).then( res => res.json());
}
